import Routes from "./routes";
import "./assets/styles/main.css";

function App() {
  return <Routes />;
}

export default App;
